import { DictType } from 'core-lib/types/Helper';
import { useRouter } from 'next/router';
import parkplusStoreV2RedirectionRoutes from '../constants/parkplusStoreV2RedirectionRoutes';
import { LayoutEntityType } from '../types/layout';
import { trackCardClickedStoreV2 } from '../utils/events';
import formatListingQuery from '../utils/listing';
import Product, { SkuType } from '../types/product';
import { useRedirection } from 'core-lib/utils/common';
import { OPEN_FEATURE } from 'core-lib/constants/nativeBridge';
import { passMessageToNative } from 'core-lib/utils/nativeBridge';

const useStoreItemClick = () => {
  const router = useRouter();
  const { push } = useRedirection();
  const handleItemClickWithDelegation = (
    e: React.MouseEvent<HTMLElement>,
    CARDID: string,
    entityType: LayoutEntityType,
    data?: Product[],
    section?: string
  ) => {
    if (e.target instanceof HTMLElement) {
      const targetElement = e.target.closest(`#${CARDID}`) as HTMLDivElement;
      if (!targetElement) return;
      const index = targetElement.dataset.index;
      handleItemClick(
        entityType,
        data?.[index]?.productId,
        data?.[index]?.filter || null,
        data?.[index]?.skuType,
        section,
        +index,
        data?.[index]?.redirectionUrl,
        data?.[index]?.eventType,
        data?.[index]?.screenId,
        data?.[index]?.screenData
      );
    }
  };
  const handleItemClick = (
    entityType: LayoutEntityType,
    id?: number,
    filters?: DictType,
    skuType?: string,
    section?: string,
    position?: number,
    redirectionUrl?: string,
    eventType?: string,
    screenId?: string,
    screenData?: DictType
  ) => {

    //for event
    if (id)
      trackCardClickedStoreV2(section, `${position}`, id, null, {
        description: eventType,
      });
    if (redirectionUrl) {
      // if url is /app/car-insurance then use window.location.href (temp fix)
      if (redirectionUrl.includes('/app/car-insurance')) {
        window.location.href = redirectionUrl;
      } else {
        push(redirectionUrl);
      }
      return;
    }
    if (screenId) {
      passMessageToNative(
        OPEN_FEATURE,
        null,
        JSON.stringify({
          screen_id: screenId,
          callback_script: `console.log()`,
          screen_data: screenData,
        }),
      );
    }
    if (skuType === SkuType.FuelVoucher) {
      router.push(parkplusStoreV2RedirectionRoutes.instantPetrol);
    }
    if (entityType === LayoutEntityType.Category && filters) {
      const query = formatListingQuery({
        filters: [filters],
      });
      router.push(`${parkplusStoreV2RedirectionRoutes.listing}?${query}`);
    } else if (id) {
      router.push(`${parkplusStoreV2RedirectionRoutes.home}/${id}`);
    }

  };

  return {
    handleItemClick,
    handleItemClickWithDelegation,
  };
};

export default useStoreItemClick;
